<template>
  <div :class="['resourceInfo', 'resourceInfo--' + resource.type]" id="resourceInfo">
    <div class="resourceInfo__block">
      <div class="resourceInfo__title">Source</div>
      <div
        v-if="resource.type === 'pdfs'"
        class="resourceInfo__content shrink"
        :title="source ? source : 'Unknown'"
        v-html="source ? links(source) : 'Unknown'"
      />

      <div
        v-else
        class="resourceInfo__content shrink"
        :title="resource && resource.attributes.source ? resource.attributes.source : 'Unknown'"
        v-html="resource && resource.attributes.source ? links(resource.attributes.source) : 'Unknown'"
      />
    </div>

    <div class="resourceInfo__block">
      <div class="resourceInfo__title">Published</div>
      <div class="resourceInfo__content" v-html="publishedDate" />
    </div>

    <div class="resourceInfo__block">
      <div class="resourceInfo__title">Uploaded</div>
      <div class="resourceInfo__content" v-html="uploadDate" />
    </div>

    <div
      v-if="resource.type === 'datasets'"
      :class="['resourceInfo__block', 'resourceInfo__block--striped', relatedPdf ? 'resourceInfo__block--stripedActive' : '']"
    >
      <div :class="['resourceInfo__title', relatedPdf ? 'resourceInfo__title--active' : '']">Related report</div>
      <div class="resourceInfo__content">
        <router-link
          v-if="loading || relatedPdf"
          :title="relatedPdf ? relatedPdf.attributes.title : ''"
          :to="relatedPdf ? '/pdfs/' + relatedPdf.id : ''"
          class="link--plain shrink"
          v-html="loading ? 'Loading...' : relatedPdf.attributes.title"
        />
        <span
          v-else
          class="text--light"
          v-html="'No reports linked to this dataset found.'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility.js'

export default {
  props: {
    resource: {
      type: [Object, String, Boolean],
      default: false
    },
    relatedPdf: {
      type: [Object, Boolean],
      default: false
    },
    originallyPublished: {
      type: [String, Boolean],
      default: false
    },
    source: {
      type: [String, Boolean],
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Boolean,
      default: false
    },
    noResults: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    uploadDate () {
      let date = 'Unknown'

      if (this.resource && this.resource.attributes.created_at) {
        let formattedDate = this.formatDate(this.resource.attributes.created_at)
        date = '<p title="' + new Date(this.resource.attributes.created_at).toUTCString() + '">' + formattedDate + ' <span class="text--light">(@ Statzon)</span></p>'
      }

      return date
    },
    publishedDate () {
      let date = 'Unknown'

      if (this.originallyPublished) {
        date = '<p title="' + this.originallyPublished + '">' + this.originallyPublished + ' <span class="text--light">(@ source)</span></p>'
      } else if (this.resource && this.resource.attributes.published_at) {
        date = '<p title="' + this.resource.attributes.published_at + '">' + this.resource.attributes.published_at + ' <span class="text--light">(@ source)</span></p>'
      }

      return date
    },


    publishedDates () {
      let publishedStatzon = ''
      let publishedOriginal = ''

      if (this.resource && this.resource.attributes.created_at) {
        let formattedDate = this.formatDate(this.resource.attributes.created_at)
        publishedStatzon = '<p title="' + new Date(this.resource.attributes.created_at).toUTCString() + '">' + formattedDate + ' <span class="text--light">(@ Statzon)</span></p>'
      }

      if (this.resource && this.resource.attributes.published_at) {
        publishedOriginal = '<p>' + this.resource.attributes.published_at + ' <span class="text--light">(@ source)</span></p>'
      }

      return publishedStatzon + publishedOriginal
    },
    originalPublishedDate () {
      let publishedOriginal = 'Unknown'

      if (this.originallyPublished) {
        publishedOriginal = this.originallyPublished + ' <span class="text--light">(@ source)</span>'
      }

      return publishedOriginal
    }
  },
  methods: {
    ...helperMethods
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.resourceInfo {
  @include font('content--md', $white);
  background-color: $bg-4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: center;
  align-self: stretch;
  border-top: 1px solid $black;

  @media screen and (min-width: $breakpointMd) {
    flex-direction: row;
  }

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white);
  }

  &--datasets {
    flex-direction: column-reverse;

    @media screen and (min-width: $breakpointMd) {
      flex-direction: row;
    }
  }

  &__block {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    padding: 1rem 1rem 1.25rem 1rem;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;

    @media screen and (min-width: $breakpointMd) {
      border-left: 1px solid rgba($white, 0.1);
      border-right: 1px solid $black;

      &:first-child {
        border-left: none;
      }

      &:last-child {
        border-right: none;
      }
    }

    &--striped {
      flex: 1.25;
      background-color: $bg-4;
      background-image: url("data:image/svg+xml,%3Csvg width='90' height='90' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%231b1e21' fill-opacity='0.3' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E");
      transition: background-image 0.5s ease-out;

      &Active {
        background-image: url("data:image/svg+xml,%3Csvg width='90' height='90' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%231593a6' fill-opacity='0.07' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E");
      }
    }
  }

  &__title {
    text-transform: uppercase;
    color: rgba($white, 0.4);
    border-bottom: 1px dotted rgba($blue, 0);
    margin: 0;
    font-weight: 500;

    &--active {
      color: rgba($white, 0.9);
      border-bottom: 1px dashed $blue;
    }
  }

  &__wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    align-content: center;
  }

  &__content {
    text-align: center;
    margin: 0;
    flex: 1;

    /deep/ p {
      margin: 0 !important;
      padding: 0 !important;
    }
  }

  &__logo {
    display: none;
    width: 28px;
    min-width: 28px;
    max-width: 28px;
    height: 28px;
    fill: rgba($white, 0.9);
    background-color: rgba($red, 0.75);
    padding: 5px 4px;
    margin: 0.25rem 0.75rem 0.25rem 0;
    box-shadow: 0 2px 1px -1px rgba($black, 0.5), 0 1px 1px 0 rgba($black, 0.5), 0 1px 3px 0 rgba($black, 0.25);
    border-radius: 4px;
    transition: background-color 0.4s ease-in-out;

    &--inactive {
      background-color: rgba($black, 0.3);
    }

    @media screen and (min-width: $breakpointSm) {
      display: block;
    }

    @media screen and (min-width: $breakpointLg) {
      width: 32px;
      min-width: 32px;
      max-width: 32px;
      height: 32px;
      margin: 0 1rem 0 0;
    }
  }
}

.shrink {
  @media screen and (min-width: $breakpointMd) {
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    margin: 0;
  }
}

</style>
